import angular from 'angular';
import constants from 'app/constants';
import {
  assetDataService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './delete-asset-confirm-dialog.controller';
import template from './delete-asset-confirm-dialog.html';


class dialogService {
  getOptions($event, {
    customerId, asset, process, isEditProcessDialog,
    assignAsset,
    isPraProcessMain,
    updateCallBack,
  }) {
    return {
      controller,
      controllerAs: 'deleteConfirmDialogVM',
      locals: {
        customerId,
        asset,
        process,
        isEditProcessDialog,
        assignAsset,
        isPraProcessMain,
        updateCallBack,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.asset.deleteAssetConfirmDialog', [
  alerts,
  assetDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('deleteAssetConfirmDialog', dialogService)
  .name;
